<template>
  <div class="bg-white relative md:pt-32 lg:pt-32 pt-24">
    <div class="absolute left-0 top-1/2 md:block lg:block hidden">
      <img
        src="../../../assets/images/bg-des/bg-half-tri-blogdetails.svg"
        alt="bg-polygon"
        class=""
      />
    </div>
    <div class="md:px-8 lg:px-16 px-0 flex w-full lg:flex-wrap">
      <div class="md:w-7/12 lg:w-3/4 w-full md:px-2 lg:px-6 px-0">
        <div class="w-full relative z-index1">
          <div class="w-full">
            <iframe
              src="https://www.youtube.com/embed/TC4HxGNJPbw"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="w-full newsiframe md:rounded-lg lg:rounded-lg rounded-none"
            ></iframe>
          </div>

          <div
            class="
              absolute
              right-16
              -bottom-32
              trans-rotate-31-blog
              z-index--1
              md:block
              lg:block
              hidden
            "
          >
            <img
              src="../../../assets/images/bg-des/team-bg-t1.svg"
              alt="bg-polygon"
              class=""
            />
          </div>
        </div>
        <div class="md:px-0 lg:px-0 px-6">
          <div class="md:mt-10 lg:mt-10 mt-6">
            <div class="flex justify-between items-center">
              <p class="fsize45-24 font-bold text-black">
                Fiinibus Bonorum et Malorum
              </p>
              <img
                src="./../../../assets/images/shareCS.png"
                alt="ShareIcon"
                class="h-6 w-6"
              />
            </div>
            <div class="md:flex lg:flex mt-2">
              <p class="font-normal fsize18px text-black font-bold">
                Phasellus nec feugiat vitae, pharetra
              </p>
              <p class="md:ml-12 lg:ml-12 fsize18px clr777">
                Monday, May 20 2021
              </p>
            </div>
          </div>
          <div class="w-full md:my-12 lg:my-12 my-6">
            <div class="hrlineblogspage"></div>
          </div>
          <div class="">
            <p class="blogsdetailstext">
              Section 1.10.32 of "de Finibus Bonorum et Malorum", written by
              Cicero in 45 BC "Sed ut perspiciatis unde omnis iste natus error
              sit voluptatem accusantium doloremque laudantium, totam rem
              aperiam, eaque ipsa quae ab illo inventore veritatis et quasi
              architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam
              voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed
              quia consequuntur magni dolores eos qui ratione voluptatem sequi
              nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor
              sit amet, consectetur, adipisci velit, sed quia non numquam eius
              modi tempora incidunt ut labore et dolore magnam aliquam quaerat
              voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem
              ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi
              consequatur? Quis autem vel eum iure reprehenderit qui in ea
              voluptate velit esse quam nihil molestiae consequatur, vel illum
              qui dolorem eum fugiat quo voluptas nulla pariatur?"
            </p>
            <p class="blogsdetailstext pt-6">
              1914 translation by H. Rackham "But I must explain to you how all
              this mistaken idea of denouncing pleasure and praising pain was
              born and I will give you a complete account of the system, and
              expound the actual teachings of the great explorer of the truth,
              the master-builder of human happiness. No one rejects, dislikes,
              or avoids pleasure itself, because it is pleasure, but because
              those who do not know how to pursue pleasure rationally encounter
              consequences that are extremely painful. Nor again is there anyone
              who loves or pursues or desires to obtain pain of itself, because
              it is pain, but because occasionally circumstances occur in which
              toil and pain can procure him some great pleasure. To take a
              trivial example, which of us ever undertakes laborious physical
              exercise, except to obtain some advantage from it? But who has any
              right to find fault with a man who chooses to enjoy a pleasure
              that has no annoying consequences, or one who avoids a pain that
              produces no resultant pleasure?"
            </p>
            <p class="text-xl text-black font-bold pt-8">
              Section 1.10.33 of "de Finibus Bonorum et Malorum"
            </p>
            <p class="blogsdetailstext pt-6">
              "At vero eos et accusamus et iusto odio dignissimos ducimus qui
              blanditiis praesentium voluptatum deleniti atque corrupti quos
              dolores et quas molestias excepturi sint occaecati cupiditate non
              provident, similique sunt in culpa qui officia deserunt mollitia
              animi, id est laborum et dolorum fuga. Et harum quidem rerum
              facilis est et expedita distinctio. Nam libero tempore, cum soluta
              nobis est eligendi optio cumque nihil impedit quo minus id quod
              maxime placeat facere possimus, omnis voluptas assumenda est,
              omnis dolor repellendus. Temporibus autem quibusdam et aut
              officiis debitis aut rerum necessitatibus saepe eveniet ut et
              voluptates repudiandae sint et molestiae non recusandae. Itaque
              earum rerum hic tenetur a sapiente delectus, ut aut reiciendis
              voluptatibus maiores alias consequatur aut perferendis doloribus
              asperiores repellat."
            </p>
            <p class="text-3xl text-black font-bold pt-8">Section</p>
            <p class="blogsdetailstext pt-6">
              "At vero eos et accusamus et iusto odio dignissimos ducimus qui
              blanditiis praesentium voluptatum deleniti atque corrupti quos
              dolores et quas molestias excepturi sint occaecati cupiditate non
              provident, similique sunt in culpa qui officia deserunt mollitia
              animi, id est laborum et dolorum fuga. Et harum quidem rerum
              facilis est et expedita distinctio. Nam libero tempore, cum soluta
              nobis est eligendi optio cumque nihil impedit quo minus id quod
              maxime placeat facere possimus, omnis voluptas assumenda est,
              omnis dolor repellendus. Temporibus autem quibusdam et aut
              officiis debitis aut rerum necessitatibus saepe eveniet ut et
              voluptates repudiandae sint et molestiae non recusandae. Itaque
              earum rerum hic tenetur a sapiente delectus, ut aut reiciendis
              voluptatibus maiores alias consequatur aut perferendis doloribus
              asperiores repellat."
            </p>
            <p class="text-3xl text-black font-bold pt-8">Section 1.10.33</p>
            <p class="blogsdetailstext pt-6">
              "At vero eos et accusamus et iusto odio dignissimos ducimus qui
              blanditiis praesentium voluptatum deleniti atque corrupti quos
              dolores et quas molestias excepturi sint occaecati cupiditate non
              provident, similique sunt in culpa qui officia deserunt mollitia
              animi, id est laborum et dolorum fuga. Et harum quidem rerum
              facilis est et expedita distinctio. Nam libero tempore, cum soluta
              nobis est eligendi optio cumque nihil impedit quo minus id quod
              maxime placeat facere possimus, omnis voluptas assumenda est,
              omnis dolor repellendus. Temporibus autem quibusdam et aut
              officiis debitis aut rerum necessitatibus saepe eveniet ut et
              voluptates repudiandae sint et molestiae non recusandae. Itaque
              earum rerum hic tenetur a sapiente delectus, ut aut reiciendis
              voluptatibus maiores alias consequatur aut perferendis doloribus
              asperiores repellat." Section 1.10.33 of "de Finibus Bonorum et
              Malorum", written by Cicero in 45 BC
            </p>
            <p class="blogsdetailstext pt-6">
              "At vero eos et accusamus et iusto odio dignissimos ducimus qui
              blanditiis praesentium voluptatum deleniti atque corrupti quos
              dolores et quas molestias excepturi sint occaecati cupiditate non
              provident, similique sunt in culpa qui officia deserunt mollitia
              animi, id est laborum et dolorum fuga. Et harum quidem rerum
              facilis est et expedita distinctio. Nam libero tempore, cum soluta
              nobis est eligendi optio cumque nihil impedit quo minus id quod
              maxime placeat facere possimus, omnis voluptas assumenda est,
              omnis dolor repellendus. Temporibus autem quibusdam et aut
              officiis debitis aut rerum necessitatibus saepe eveniet ut et
              voluptates repudiandae sint et molestiae non recusandae. Itaque
              earum rerum hic tenetur a sapiente delectus, ut aut reiciendis
              voluptatibus maiores alias consequatur aut perferendis doloribus
              asperiores repellat."
            </p>
          </div>
        </div>
      </div>
      <div class="md:w-5/12 lg:w-1/4 w-full lg:px-6 md:px-2 px-2 md:block lg:block hidden">
        <p class="">Related Presentations</p>
        <div class="w-full pb-8" v-for="(item, index) in 15" :key="index">
          <div class="flex">
            <div class="w-1/4 mx-auto">
              <img
                src="./../../../assets/images/news4.jpg"
                alt="Blogs"
                class="h-20 w-20 rounded-md mx-auto"
              />
            </div>
            <div class="w-3/4 my-auto pl-4">
              <p class="mc-title text-black font-bold">
                News Title Lorem Ipsum Lorem Ipsum
              </p>
              <p class="fsize18px clr777">5 minute read</p>
            </div>
          </div>
          <!-- <img
            src="./../../../assets/images/news4.jpg"
            alt="News"
            class="w-full h-52 rounded-lg"
          />
          <p class="font-bold text-xl text-black mt-2 px-2">
            News Title Lorem Ipsum
          </p>
          <div class="mt-1 flex px-2">
            <p class=" text-xs clr777 font-normal">1 Hour ago</p>
            <p class=" text-xs clr777 font-normal ml-6">200 views</p>
          </div> -->
        </div>
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555 mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import DownloadApp from "../../home/components/DownloadApp.vue";
import Footer from "../../Footer.vue";
export default {
  components: {
    DownloadApp,
    Footer,
  },
};
</script>
